var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLinkR({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 24,
    viewBox: "0 0 16 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;opacity:0;}.b{fill:#23629b;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-341 -3612)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 16,
    height: 24,
    transform: "translate(341 3612)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,9.487a1,1,0,0,1-1-1L-1,0A1,1,0,0,1,0-1,1,1,0,0,1,1,0L1,8.488A1,1,0,0,1,0,9.487Z",
    transform: "translate(345.998 3618.002) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,1A1,1,0,0,1-1,0,1,1,0,0,1,0-1L8.487-1a1,1,0,0,1,1,1,1,1,0,0,1-1,1Z",
    transform: "translate(345.998 3629.998) rotate(-45)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinkR);
export default __webpack_public_path__ + "static/media/icon_link_r.eb23740a82ebbfa3e56983ab239aeba8.svg";
export { ForwardRef as ReactComponent };